export const MODAL_STATES_CONSTANTS = {
  cart_modal: 'cart_modal',
  food_modal: 'food_modal',
  coupon_modal: 'coupon_modal',
  modify_cart_modal: 'modify_cart_modal',
  booking_info_modal: 'booking_info_modal',
  all_room: 'all_room',
  ind_room: 'ind_room',
  multi_room_warning: 'multi_room_warning',
  map_modal: 'map_modal',
};
/*
this.b2bDeviceUtilService.removeFakeModalStateFromHistory('cart_modal');
this.b2bDeviceUtilService.removeFakeModalStateFromHistory('food_modal');
this.b2bDeviceUtilService.removeFakeModalStateFromHistory('coupon_modal');
this.b2bDeviceUtilService.removeFakeModalStateFromHistory('modify_cart_modal',
);
this.b2bDeviceUtilService.removeFakeModalStateFromHistory('booking_info_modal',

this.b2bDeviceUtilService.removeFakeModalStateFromHistory('all_room');
this.b2bDeviceUtilService.removeFakeModalStateFromHistory('ind_room');
this.b2bDeviceUtilService.removeFakeModalStateFromHistory(
      'multi_room_warning',
    );
);*/
